document.addEventListener('DOMContentLoaded', function() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params.customer_posted === 'true') {
        window.location.href = '/pages/thank-you';
        return;
    }

    initContinueShoppingContext();
    initGridProductForms();
    initCustomerReorders();
    initFreeDeliveryNotices();
});

const CONTINUE_SHOPPING_STORAGE_KEY = 'continue-shopping-context';
const CONTINUE_SHOPPING_MAX_AGE = 7 * 24 * 60 * 60 * 1000;
const FREE_DELIVERY_NOTICE_SELECTOR = '[data-free-delivery-notice]';
const REORDER_NOTICE_STORAGE_KEY = 'customer-reorder-notice';
const REORDER_GENERIC_ERROR_MESSAGE = 'Unable to add this order to your cart right now.';
const CLERK_PRODUCT_CONTROL_TEMPLATES = [
    '@homepage-popular',
    '@homepage-visitor-complementary',
    '@product-page-alternatives',
    '@product-page-others-also-bought',
    '@cart-others-also-bought'
];
const CLERK_PRODUCT_CONTROL_CONTAINER_SELECTOR = [
    '.clerk-omnisearch-overlay',
    '#clerk-omni-search-display',
    '#clerk-omni-search-results[data-result-type="products"]'
].concat(CLERK_PRODUCT_CONTROL_TEMPLATES.map(function(templateName) {
    return '.clerk[data-template="' + templateName + '"]';
})).join(',');
const CLERK_PRODUCT_CONTROL_CACHE = new Map();
let clerkProductControlCounter = 0;

function initContinueShoppingContext() {
    bindContinueShoppingTracking();
    updateContinueShoppingLink();
}

function initGridProductForms() {
    bindGridProductQuantityControls();
    bindGridProductAddToCart();
    bindClerkProductControls();
}

function initCustomerReorders() {
    bindCustomerReorderButtons();
    showStoredCustomerReorderNotice();
}

function initFreeDeliveryNotices() {
    if (!document.querySelector(FREE_DELIVERY_NOTICE_SELECTOR)) {
        return;
    }

    updateFreeDeliveryNoticesFromMarkup();

    document.addEventListener('cart:updated', function(event) {
        const cart = event.detail && event.detail.cart ? event.detail.cart : null;

        if (!cart) {
            return;
        }

        updateFreeDeliveryNotices(cart.total_price, cart.item_count);
    });

    document.addEventListener('ajaxProduct:added', function() {
        refreshFreeDeliveryNoticesFromCart();
    });
}

function updateFreeDeliveryNoticesFromMarkup() {
    document.querySelectorAll(FREE_DELIVERY_NOTICE_SELECTOR).forEach(function(notice) {
        const subtotal = parseInt(notice.dataset.freeDeliverySubtotal, 10);
        const itemCount = parseInt(notice.dataset.itemCount, 10);

        updateFreeDeliveryNotice(
            notice,
            Number.isNaN(subtotal) ? 0 : subtotal,
            Number.isNaN(itemCount) ? 0 : itemCount
        );
    });
}

function refreshFreeDeliveryNoticesFromCart() {
    if (!(window.theme && theme.cart && typeof theme.cart.getCart === 'function')) {
        return;
    }

    theme.cart.getCart()
        .then(function(cart) {
            if (!cart) {
                return;
            }

            updateFreeDeliveryNotices(cart.total_price, cart.item_count);
        })
        .catch(function() {
        });
}

function updateFreeDeliveryNotices(subtotal, itemCount) {
    document.querySelectorAll(FREE_DELIVERY_NOTICE_SELECTOR).forEach(function(notice) {
        updateFreeDeliveryNotice(notice, subtotal, itemCount);
    });
}

function updateFreeDeliveryNotice(notice, subtotal, itemCount) {
    const threshold = parseInt(notice.dataset.threshold, 10);

    if (Number.isNaN(threshold) || threshold < 1) {
        notice.hidden = true;
        return;
    }

    const safeSubtotal = Math.max(0, parseInt(subtotal, 10) || 0);
    const safeItemCount = Math.max(0, parseInt(itemCount, 10) || 0);
    const amountLeft = Math.max(threshold - safeSubtotal, 0);
    const messageElement = notice.querySelector('[data-free-delivery-message-text]');

    notice.dataset.freeDeliverySubtotal = safeSubtotal;
    notice.dataset.itemCount = safeItemCount;
    notice.hidden = safeItemCount < 1;
    notice.classList.toggle('is-earned', amountLeft === 0);

    if (messageElement) {
        messageElement.textContent = amountLeft === 0
            ? 'You\'ve unlocked free delivery.'
            : formatFreeDeliveryMoney(amountLeft) + ' left for free delivery.';
    }
}

function formatFreeDeliveryMoney(cents) {
    if (
        window.theme &&
        theme.Currency &&
        typeof theme.Currency.formatMoney === 'function' &&
        theme.settings &&
        theme.settings.moneyFormat
    ) {
        return stripHtml(theme.Currency.formatMoney(cents, theme.settings.moneyFormat));
    }

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
    }).format((cents || 0) / 100);
}

function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '').trim();
}

function bindContinueShoppingTracking() {
    document.addEventListener('submit', function(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !isProductAddForm(form)) {
            return;
        }

        saveContinueShoppingContext(form);
    }, true);

    document.addEventListener('ajaxProduct:added', function(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !isProductAddForm(form)) {
            return;
        }

        saveContinueShoppingContext(form);
    });
}

function bindGridProductQuantityControls() {
    document.addEventListener('click', function(event) {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const button = target.closest('.grid-product__form .js-qty__adjust');
        if (!button) {
            return;
        }

        const wrapper = button.closest('.js-qty__wrapper');
        const input = wrapper ? wrapper.querySelector('.js-qty__num') : null;
        if (!input) {
            return;
        }

        const min = getGridProductMinQuantity(input);
        const currentQty = getGridProductQuantityValue(input);
        const nextQty = button.classList.contains('js-qty__adjust--plus')
            ? currentQty + 1
            : Math.max(min, currentQty - 1);

        input.value = nextQty;
    });

    document.addEventListener('change', function(event) {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const input = target.closest('.grid-product__form .js-qty__num');
        if (!input) {
            return;
        }

        const min = getGridProductMinQuantity(input);
        input.value = Math.max(min, getGridProductQuantityValue(input));
    });
}

function bindGridProductAddToCart() {
    document.addEventListener('submit', function(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement) || !form.classList.contains('grid-product__form')) {
            return;
        }

        if (!shouldAjaxSubmitGridProductForm()) {
            return;
        }

        event.preventDefault();

        if (form.dataset.isSubmitting === 'true') {
            return;
        }

        const addToCartButton = form.querySelector('[data-add-to-cart]');
        if (!addToCartButton || addToCartButton.disabled) {
            return;
        }

        clearGridProductFormErrors(form);
        form.dataset.isSubmitting = 'true';
        addToCartButton.classList.add('btn--loading');

        fetch(getGridProductCartAddUrl(form), {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                if (data.status === 422) {
                    handleGridProductFormError(form, data);
                    return;
                }

                if (shouldReloadCartPageAfterGridProductAdd()) {
                    window.location.reload();
                    return;
                }

                form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data,
                        addToCartBtn: addToCartButton
                    },
                    bubbles: true
                }));
            })
            .catch(function() {
                handleGridProductFormError(form, {
                    description: 'Unable to add this item to your cart right now.'
                });
            })
            .finally(function() {
                form.dataset.isSubmitting = 'false';
                addToCartButton.classList.remove('btn--loading');
            });
    });
}

function bindClerkProductControls() {
    const enhance = debounceClerkProductControlEnhancement();

    enhance();
    window.setTimeout(enhance, 500);
    window.setTimeout(enhance, 1500);
    window.setTimeout(enhance, 3000);

    document.addEventListener('clerk:content', enhance);
    document.addEventListener('recommendations:loaded', enhance);
    window.addEventListener('load', enhance);

    const observer = new MutationObserver(function(mutations) {
        const hasProductCardChange = mutations.some(function(mutation) {
            return Array.from(mutation.addedNodes).some(function(node) {
                return node instanceof Element && (
                    node.matches(CLERK_PRODUCT_CONTROL_CONTAINER_SELECTOR) ||
                    node.matches('.os-grid-item.os-grid-product') ||
                    node.closest(CLERK_PRODUCT_CONTROL_CONTAINER_SELECTOR) ||
                    node.querySelector(CLERK_PRODUCT_CONTROL_CONTAINER_SELECTOR) ||
                    node.querySelector('.os-grid-item.os-grid-product')
                );
            });
        });

        if (hasProductCardChange) {
            enhance();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function debounceClerkProductControlEnhancement() {
    let timer;

    return function() {
        clearTimeout(timer);
        timer = setTimeout(enhanceClerkProductControls, 100);
    };
}

function enhanceClerkProductControls() {
    document.querySelectorAll(CLERK_PRODUCT_CONTROL_CONTAINER_SELECTOR).forEach(function(container) {
        enhanceClerkProductControlContainer(container);
    });
}

function enhanceClerkProductControlContainer(container) {
    const cardMap = new Map();

    normalizeClerkProductControlContainer(container);

    getClerkProductControlCardData(container).forEach(function(cardData) {
        const card = cardData.card;

        if (!cardData.handle || !card || card.dataset.clerkProductControlsEnhanced === 'loading') {
            return;
        }

        card.classList.add('clerk-product-controls-card');

        if (hasExistingClerkProductControls(card)) {
            card.dataset.clerkProductControlsEnhanced = 'existing';
            return;
        }

        if (card.dataset.clerkProductControlsEnhanced === 'true') {
            return;
        }

        cardMap.set(card, {
            card: card,
            handle: cardData.handle,
            productLink: cardData.productLink
        });
    });

    cardMap.forEach(enhanceClerkProductControlCard);
}

function getClerkProductControlCardData(container) {
    const cardData = [];
    const cards = Array.from(container.querySelectorAll([
        '.os-grid-item.os-grid-product',
        '.clerk_product-card',
        '.clerk-product-card'
    ].join(',')));

    cards.forEach(function(card) {
        const productLink = getClerkProductControlLink(card);
        const handle = productLink ? getProductHandleFromUrl(productLink.href) : '';

        if (handle) {
            cardData.push({
                card: card,
                handle: handle,
                productLink: productLink
            });
        }
    });

    if (cardData.length) {
        return cardData;
    }

    container.querySelectorAll('a[href*="/products/"]').forEach(function(productLink) {
        const handle = getProductHandleFromUrl(productLink.href);
        const card = getClerkProductControlCard(productLink, container);

        if (handle && card) {
            cardData.push({
                card: card,
                handle: handle,
                productLink: productLink
            });
        }
    });

    return cardData;
}

function getClerkProductControlLink(card) {
    if (card.matches('a[href*="/products/"]')) {
        return card;
    }

    return card.querySelector('a[href*="/products/"]');
}

function normalizeClerkProductControlContainer(container) {
    if (container.matches('.clerk-omnisearch-overlay, #clerk-omni-search-display, #clerk-omni-search-results')) {
        return;
    }

    container.querySelectorAll('.clerk_product-card, .clerk-product-card').forEach(function(card) {
        const purchases = Array.from(card.querySelectorAll('.clerk-product__purchase'));
        const imageWrapper = card.querySelector('.clerk_img-wrapper, .clerk-image-wrapper');

        if (purchases.length > 1) {
            purchases.forEach(function(purchase) {
                purchase.remove();
            });
            clearClerkProductControlEnhancementState(card);
            return;
        }

        if (purchases.length === 1 && imageWrapper && purchases[0].parentElement !== card) {
            imageWrapper.insertAdjacentElement('afterend', purchases[0]);
        }
    });
}

function clearClerkProductControlEnhancementState(card) {
    card.removeAttribute('data-clerk-product-controls-enhanced');
    card.classList.remove('clerk-product-controls-card');

    card.querySelectorAll('[data-clerk-product-controls-enhanced]').forEach(function(enhancedCard) {
        enhancedCard.removeAttribute('data-clerk-product-controls-enhanced');
        enhancedCard.classList.remove('clerk-product-controls-card');
    });
}

function hasExistingClerkProductControls(card) {
    const generatedControls = card.querySelector([
        '.clerk-product__purchase[data-clerk-product-controls="true"]',
        '.grid-product__purchase:not(.clerk-product__purchase)'
    ].join(','));
    const addControl = card.querySelector([
        'form[action*="/cart/add"]',
        '[data-add-to-cart]',
        'button[name="add"]',
        'button[type="submit"]',
        'input[type="submit"]'
    ].join(','));
    const quantityControl = card.querySelector([
        'input[name="quantity"]',
        'select[name="quantity"]',
        '.js-qty__wrapper'
    ].join(','));

    return Boolean(generatedControls || (addControl && quantityControl));
}

function getClerkProductControlCard(productLink, container) {
    const selectors = [
        '.os-grid-item.os-grid-product',
        '.clerk_product-card',
        '.clerk-product-card',
        '[data-clerk-product-id]',
        '[data-clerk-product]',
        '[data-product-id]',
        '[data-product]',
        '.clerk-product',
        '.clerk_product',
        '.clerk-item',
        '.clerk_item',
        '.product-card',
        '.product',
        'li',
        'article'
    ];

    for (let index = 0; index < selectors.length; index += 1) {
        const card = productLink.closest(selectors[index]);

        if (card && card !== productLink && card !== container && container.contains(card)) {
            return card;
        }
    }

    const plainCard = getPlainClerkProductControlCard(productLink, container);
    if (plainCard) {
        return plainCard;
    }

    if (productLink.parentElement && productLink.parentElement !== container) {
        return productLink.parentElement;
    }

    return productLink;
}

function getPlainClerkProductControlCard(productLink, container) {
    const linkRect = productLink.getBoundingClientRect();
    let candidate = productLink.parentElement;
    let fallback = null;

    while (candidate && candidate !== container && container.contains(candidate)) {
        const candidateRect = candidate.getBoundingClientRect();
        const productLinks = candidate.querySelectorAll('a[href*="/products/"]');
        const hasProductImage = Boolean(candidate.querySelector('img, picture, [style*="background-image"]'));
        const looksLikeCard = productLinks.length > 0 &&
            productLinks.length <= 2 &&
            candidateRect.width >= linkRect.width &&
            candidateRect.height > linkRect.height + 80;

        if (looksLikeCard && hasProductImage) {
            return candidate;
        }

        if (looksLikeCard) {
            fallback = candidate;
        }

        candidate = candidate.parentElement;
    }

    return fallback;
}

function getProductHandleFromUrl(url) {
    try {
        const parsedUrl = new URL(url, window.location.origin);
        const productIndex = parsedUrl.pathname.split('/').indexOf('products');

        if (productIndex === -1) {
            return '';
        }

        return parsedUrl.pathname.split('/')[productIndex + 1] || '';
    } catch (error) {
        return '';
    }
}

function enhanceClerkProductControlCard(cardData) {
    const card = cardData.card;

    card.dataset.clerkProductControlsEnhanced = 'loading';

    getClerkProductControlProduct(cardData.handle)
        .then(function(product) {
            const variant = getClerkProductControlVariant(product);

            if (!variant) {
                card.dataset.clerkProductControlsEnhanced = 'unavailable';
                return;
            }

            const purchase = buildClerkProductControlPurchase(product, variant, cardData.handle);
            insertClerkProductControlPurchase(card, cardData.productLink, purchase);
            card.dataset.clerkProductControlsEnhanced = 'true';
        })
        .catch(function() {
            card.dataset.clerkProductControlsEnhanced = 'failed';
        });
}

function getClerkProductControlProduct(handle) {
    if (!CLERK_PRODUCT_CONTROL_CACHE.has(handle)) {
        CLERK_PRODUCT_CONTROL_CACHE.set(
            handle,
            fetch(getProductJsonUrl(handle), {
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json'
                }
            }).then(function(response) {
                if (!response.ok) {
                    throw new Error('Unable to load product JSON for ' + handle);
                }

                return response.json();
            })
        );
    }

    return CLERK_PRODUCT_CONTROL_CACHE.get(handle);
}

function getProductJsonUrl(handle) {
    const rootUrl = window.theme && theme.routes && theme.routes.home
        ? theme.routes.home
        : '/';
    const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

    return normalizedRootUrl + 'products/' + encodeURIComponent(handle) + '.js';
}

function getClerkProductControlVariant(product) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
        return null;
    }

    return product.variants.find(function(variant) {
        return variant.available;
    }) || product.variants[0];
}

function buildClerkProductControlPurchase(product, variant, handle) {
    const formId = 'ClerkProductControlForm-' + product.id + '-' + variant.id + '-' + (++clerkProductControlCounter);
    const qtyId = formId + '-Qty';
    const purchase = document.createElement('div');
    const form = document.createElement('form');
    const variantInput = document.createElement('input');
    const actions = document.createElement('div');
    const quantity = document.createElement('div');
    const quantityLabel = document.createElement('label');
    const quantityWrapper = buildClerkProductControlQuantityInput(formId, qtyId);
    const button = document.createElement('button');
    const buttonText = document.createElement('span');
    const isAvailable = Boolean(variant.available);

    purchase.className = 'grid-product__purchase clerk-product__purchase';
    purchase.dataset.clerkProductControls = 'true';

    form.method = 'post';
    form.action = getCartAddFormAction();
    form.id = formId;
    form.className = 'product-single__form grid-product__form';
    form.dataset.productid = product.id;
    form.dataset.productUrl = product.url || '/products/' + handle;
    form.dataset.collectionUrl = getCurrentCollectionUrlForGridForm();

    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = variant.id;

    actions.className = 'grid-product__actions';
    quantity.className = 'grid-product__quantity';

    quantityLabel.className = 'visually-hidden';
    quantityLabel.htmlFor = 'Quantity-' + qtyId;
    quantityLabel.textContent = 'Quantity';

    button.type = 'submit';
    button.name = 'add';
    button.className = 'btn add-to-cart grid-product__add-to-cart';
    button.setAttribute('data-add-to-cart', '');

    if (!isAvailable) {
        button.disabled = true;
    }

    buttonText.setAttribute('data-add-to-cart-text', '');
    buttonText.dataset.defaultText = getGridProductAddToCartText();
    buttonText.textContent = isAvailable ? getGridProductAddToCartText() : getGridProductSoldOutText();

    quantity.appendChild(quantityLabel);
    quantity.appendChild(quantityWrapper);
    button.appendChild(buttonText);
    actions.appendChild(quantity);
    actions.appendChild(button);
    form.appendChild(variantInput);
    form.appendChild(actions);
    purchase.appendChild(form);

    return purchase;
}

function buildClerkProductControlQuantityInput(formId, qtyId) {
    const wrapper = document.createElement('div');
    const input = document.createElement('input');
    const minusButton = document.createElement('button');
    const plusButton = document.createElement('button');

    wrapper.className = 'js-qty__wrapper';

    input.type = 'text';
    input.id = 'Quantity-' + qtyId;
    input.className = 'js-qty__num';
    input.value = '1';
    input.min = '1';
    input.setAttribute('aria-label', 'quantity');
    input.setAttribute('pattern', '[0-9]*');
    input.setAttribute('form', formId);
    input.name = 'quantity';

    minusButton.type = 'button';
    minusButton.className = 'js-qty__adjust js-qty__adjust--minus';
    minusButton.setAttribute('aria-label', 'Reduce item quantity by one');
    minusButton.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg><span class="icon__fallback-text" aria-hidden="true">&minus;</span>';

    plusButton.type = 'button';
    plusButton.className = 'js-qty__adjust js-qty__adjust--plus';
    plusButton.setAttribute('aria-label', 'Increase item quantity by one');
    plusButton.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg><span class="icon__fallback-text" aria-hidden="true">+</span>';

    wrapper.appendChild(input);
    wrapper.appendChild(minusButton);
    wrapper.appendChild(plusButton);

    return wrapper;
}

function insertClerkProductControlPurchase(card, productLink, purchase) {
    const link = productLink.closest('a[href*="/products/"]') || productLink;
    const isOmnisearchCard = Boolean(card.closest('.clerk-omnisearch-overlay, #clerk-omni-search-display'));

    if (!isOmnisearchCard && !card.matches('a[href*="/products/"]')) {
        card.appendChild(purchase);
        return;
    }

    if (!isOmnisearchCard && link && link.parentElement && card.contains(link)) {
        link.insertAdjacentElement('beforebegin', purchase);
        return;
    }

    if (link && link.parentElement && card.contains(link)) {
        link.insertAdjacentElement('afterend', purchase);
        return;
    }

    card.appendChild(purchase);
}

function getGridProductAddToCartText() {
    return formatGridProductButtonText(
        window.theme && theme.strings && theme.strings.addToCart
            ? theme.strings.addToCart
            : 'Add to cart'
    );
}

function getGridProductSoldOutText() {
    return formatGridProductButtonText(
        window.theme && theme.strings && theme.strings.soldOut
            ? theme.strings.soldOut
            : 'Sold out'
    );
}

function formatGridProductButtonText(text) {
    return String(text)
        .toLowerCase()
        .split(' ')
        .map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

function bindCustomerReorderButtons() {
    document.addEventListener('click', function(event) {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const trigger = target.closest('[data-reorder-trigger]');
        if (!trigger || !(trigger instanceof HTMLButtonElement)) {
            return;
        }

        const reorder = trigger.closest('[data-customer-reorder]');
        if (!reorder || reorder.dataset.isSubmitting === 'true' || trigger.disabled) {
            return;
        }

        event.preventDefault();

        const items = getCustomerReorderItems(reorder);
        if (!items.length) {
            updateCustomerReorderStatus(reorder, 'No available items from this order can be reordered right now.');
            return;
        }

        reorder.dataset.isSubmitting = 'true';
        updateCustomerReorderStatus(reorder, '');
        setCustomerReorderLoadingState(trigger, true);

        addCustomerReorderItems(items)
            .then(function(result) {
                const unavailableCount = getCustomerReorderUnavailableCount(reorder);

                if (!result.addedItems.length) {
                    const firstError = result.failedItems[0];
                    updateCustomerReorderStatus(
                        reorder,
                        firstError && firstError.errorMessage
                            ? firstError.errorMessage
                            : REORDER_GENERIC_ERROR_MESSAGE
                    );
                    return;
                }

                if (result.failedItems.length || unavailableCount > 0) {
                    setStorageItem(
                        REORDER_NOTICE_STORAGE_KEY,
                        buildCustomerReorderNotice(result.failedItems.length, unavailableCount)
                    );
                    window.location.href = getCustomerReorderCartUrl(reorder);
                    return;
                }

                removeStorageItem(REORDER_NOTICE_STORAGE_KEY);
                window.location.href = getCustomerReorderCheckoutUrl(reorder);
            })
            .catch(function() {
                updateCustomerReorderStatus(reorder, REORDER_GENERIC_ERROR_MESSAGE);
            })
            .finally(function() {
                reorder.dataset.isSubmitting = 'false';
                setCustomerReorderLoadingState(trigger, false);
            });
    });
}

function isProductAddForm(form) {
    if (!form.classList.contains('product-single__form')) {
        return false;
    }

    try {
        const formAction = new URL(form.getAttribute('action') || '', window.location.origin);
        return formAction.pathname.indexOf('/cart/add') !== -1;
    } catch (error) {
        return false;
    }
}

function shouldAjaxSubmitGridProductForm() {
    return Boolean(
        window.theme &&
        theme.settings &&
        theme.settings.cartType === 'drawer' &&
        theme.routes &&
        theme.routes.cartAdd
    );
}

function shouldReloadCartPageAfterGridProductAdd() {
    return document.body.classList.contains('template-cart');
}

async function addCustomerReorderItems(items) {
    const mergedItems = mergeCustomerReorderItems(items);

    if (!mergedItems.length) {
        return {
            addedItems: [],
            failedItems: []
        };
    }

    const batchResult = await addCustomerReorderBatch(mergedItems);
    if (batchResult.success) {
        return {
            addedItems: mergedItems,
            failedItems: []
        };
    }

    if (mergedItems.length === 1) {
        return {
            addedItems: [],
            failedItems: [{
                item: mergedItems[0],
                errorMessage: batchResult.errorMessage
            }]
        };
    }

    return addCustomerReorderItemsSequentially(mergedItems);
}

async function addCustomerReorderBatch(items) {
    try {
        const response = await fetch(getCustomerReorderCartAddUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: items
            })
        });
        const data = await parseCustomerReorderResponse(response);

        if (!response.ok) {
            return {
                success: false,
                errorMessage: getCustomerReorderErrorMessage(data)
            };
        }

        return {
            success: true,
            data: data
        };
    } catch (error) {
        return {
            success: false,
            errorMessage: REORDER_GENERIC_ERROR_MESSAGE
        };
    }
}

async function addCustomerReorderItemsSequentially(items) {
    const addedItems = [];
    const failedItems = [];

    for (let index = 0; index < items.length; index += 1) {
        const item = items[index];
        const result = await addCustomerReorderBatch([item]);

        if (result.success) {
            addedItems.push(item);
        } else {
            failedItems.push({
                item: item,
                errorMessage: result.errorMessage
            });
        }
    }

    return {
        addedItems: addedItems,
        failedItems: failedItems
    };
}

async function parseCustomerReorderResponse(response) {
    const text = await response.text();

    if (!text) {
        return {};
    }

    try {
        return JSON.parse(text);
    } catch (error) {
        return {};
    }
}

function mergeCustomerReorderItems(items) {
    const mergedItems = new Map();

    items.forEach(function(item) {
        const id = parseInt(item && item.id, 10);
        const quantity = parseInt(item && item.quantity, 10);

        if (Number.isNaN(id) || Number.isNaN(quantity) || quantity < 1) {
            return;
        }

        mergedItems.set(id, (mergedItems.get(id) || 0) + quantity);
    });

    return Array.from(mergedItems.entries()).map(function(entry) {
        return {
            id: entry[0],
            quantity: entry[1]
        };
    });
}

function getCustomerReorderItems(reorder) {
    const itemsScript = reorder.querySelector('[data-reorder-items]');

    if (!itemsScript) {
        return [];
    }

    try {
        const parsedItems = JSON.parse(itemsScript.textContent || '[]');
        return Array.isArray(parsedItems) ? mergeCustomerReorderItems(parsedItems) : [];
    } catch (error) {
        return [];
    }
}

function getCustomerReorderCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
        return theme.routes.cartAdd;
    }

    return '/cart/add.js';
}

function getCustomerReorderCartUrl(reorder) {
    if (reorder.dataset.cartUrl) {
        return reorder.dataset.cartUrl;
    }

    if (window.theme && theme.routes && theme.routes.cartPage) {
        return theme.routes.cartPage;
    }

    return '/cart';
}

function getCustomerReorderCheckoutUrl(reorder) {
    if (reorder.dataset.checkoutUrl) {
        return reorder.dataset.checkoutUrl;
    }

    if (window.theme && theme.routes && theme.routes.home) {
        return theme.routes.home + 'checkout';
    }

    return '/checkout';
}

function getCustomerReorderUnavailableCount(reorder) {
    const unavailableCount = parseInt(reorder.dataset.unavailableCount, 10);

    if (Number.isNaN(unavailableCount) || unavailableCount < 0) {
        return 0;
    }

    return unavailableCount;
}

function getCustomerReorderErrorMessage(error) {
    if (error && typeof error.description === 'string' && error.description.trim() !== '') {
        return error.description;
    }

    return REORDER_GENERIC_ERROR_MESSAGE;
}

function setCustomerReorderLoadingState(trigger, isLoading) {
    const buttonText = trigger.querySelector('[data-reorder-button-text]');

    if (isLoading) {
        trigger.classList.add('btn--loading');
        trigger.disabled = true;
        if (buttonText) {
            buttonText.textContent = trigger.dataset.loadingText || 'Adding order...';
        }
        return;
    }

    trigger.classList.remove('btn--loading');
    trigger.disabled = trigger.getAttribute('aria-disabled') === 'true';

    if (buttonText) {
        buttonText.textContent = trigger.dataset.defaultText || 'Buy again';
    }
}

function updateCustomerReorderStatus(reorder, message) {
    const status = reorder.querySelector('[data-reorder-status]');

    if (!status) {
        return;
    }

    if (!message) {
        status.hidden = true;
        status.textContent = '';
        return;
    }

    status.hidden = false;
    status.textContent = message;
}

function buildCustomerReorderNotice(failedItemCount, unavailableItemCount) {
    const skippedItemCount = failedItemCount + unavailableItemCount;

    if (skippedItemCount <= 0) {
        return 'We added this order to your cart.';
    }

    return 'We added the available products from this order to your cart. ' +
        formatCustomerReorderItemCount(skippedItemCount) +
        ' from the original order could not be added and need review before checkout.';
}

function formatCustomerReorderItemCount(count) {
    return count === 1 ? '1 item' : count + ' items';
}

function showStoredCustomerReorderNotice() {
    if (!document.body.classList.contains('template-cart')) {
        return;
    }

    const noticeMessage = getStorageItem(REORDER_NOTICE_STORAGE_KEY);
    if (!noticeMessage) {
        return;
    }

    removeStorageItem(REORDER_NOTICE_STORAGE_KEY);

    const cartPage = document.querySelector('.page-width.page-content');
    if (!cartPage) {
        return;
    }

    const cartHeader = cartPage.querySelector('.section-header');
    const notice = document.createElement('div');
    notice.classList.add('errors', 'customer-reorder__notice');
    notice.setAttribute('role', 'alert');
    notice.textContent = noticeMessage;

    if (cartHeader && cartHeader.parentNode) {
        cartHeader.insertAdjacentElement('afterend', notice);
        return;
    }

    cartPage.insertAdjacentElement('afterbegin', notice);
}

function getGridProductCartAddUrl(form) {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
        return theme.routes.cartAdd;
    }

    return form.getAttribute('action') || '/cart/add';
}

function getCartAddFormAction() {
    const cartAddRoute = window.theme && theme.routes && theme.routes.cartAdd
        ? theme.routes.cartAdd
        : '/cart/add.js';

    return cartAddRoute.replace(/\.js(\?.*)?$/, '$1') || '/cart/add';
}

function getCurrentCollectionUrlForGridForm() {
    if (!document.body.classList.contains('template-collection')) {
        return '';
    }

    return normalizePath(window.location.pathname + window.location.search);
}

function getGridProductQuantityValue(input) {
    const quantity = parseInt(input.value, 10);

    if (Number.isNaN(quantity) || quantity < 1) {
        return 1;
    }

    return quantity;
}

function getGridProductMinQuantity(input) {
    const min = parseInt(input.getAttribute('min'), 10);

    if (Number.isNaN(min) || min < 1) {
        return 1;
    }

    return min;
}

function clearGridProductFormErrors(form) {
    const errors = form.querySelector('.errors');
    if (errors) {
        errors.remove();
    }
}

function handleGridProductFormError(form, error) {
    clearGridProductFormErrors(form);

    const errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = typeof error.description === 'string'
        ? error.description
        : 'Unable to add this item to your cart right now.';

    form.appendChild(errorDiv);
    form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
            errorMessage: errorDiv.textContent
        },
        bubbles: true
    }));
}

function saveContinueShoppingContext(form) {
    const context = getContinueShoppingContext(form);

    if (!context.collectionUrl && !context.productUrl) {
        return;
    }

    setStorageItem(CONTINUE_SHOPPING_STORAGE_KEY, JSON.stringify(context));
}

function getContinueShoppingContext(form) {
    const currentUrl = normalizePath(window.location.pathname + window.location.search);
    const productUrl = getProductUrl(form, currentUrl);

    return {
        collectionUrl: getCollectionUrl(form, currentUrl),
        productUrl: productUrl,
        savedAt: Date.now()
    };
}

function getCollectionUrl(form, currentUrl) {
    if (document.body.classList.contains('template-collection')) {
        return currentUrl;
    }

    const collectionUrl = normalizePath(form.dataset.collectionUrl);
    if (collectionUrl && !document.body.classList.contains('template-product')) {
        return collectionUrl;
    }

    return '';
}

function getProductUrl(form, currentUrl) {
    const formProductUrl = normalizePath(form.dataset.productUrl);
    if (formProductUrl) {
        return formProductUrl;
    }

    if (document.body.classList.contains('template-product')) {
        return currentUrl;
    }

    const section = form.closest('[data-product-url]');
    const sectionProductUrl = section ? normalizePath(section.dataset.productUrl) : '';
    if (sectionProductUrl) {
        return sectionProductUrl;
    }

    return normalizePath(form.dataset.productUrl);
}
function updateContinueShoppingLink() {
    const continueShoppingWrapper = document.querySelector('[data-continue-shopping]');
    if (!continueShoppingWrapper) {
        return;
    }

    const continueShoppingLink = continueShoppingWrapper.querySelector('a');
    if (!continueShoppingLink) {
        return;
    }

    const context = getStoredContinueShoppingContext();
    if (!context) {
        return;
    }

    const destination = context.collectionUrl || context.productUrl || continueShoppingWrapper.dataset.defaultUrl;
    if (!destination) {
        return;
    }

    continueShoppingLink.setAttribute('href', destination);
}

function getStoredContinueShoppingContext() {
    const storedValue = getStorageItem(CONTINUE_SHOPPING_STORAGE_KEY);

    if (!storedValue) {
        return null;
    }

    try {
        const parsedValue = JSON.parse(storedValue);

        if (!parsedValue.savedAt || (Date.now() - parsedValue.savedAt) > CONTINUE_SHOPPING_MAX_AGE) {
            removeStorageItem(CONTINUE_SHOPPING_STORAGE_KEY);
            return null;
        }

        return {
            collectionUrl: normalizePath(parsedValue.collectionUrl),
            productUrl: normalizePath(parsedValue.productUrl)
        };
    } catch (error) {
        removeStorageItem(CONTINUE_SHOPPING_STORAGE_KEY);
        return null;
    }
}

function normalizePath(url) {
    if (!url) {
        return '';
    }

    try {
        const parsedUrl = new URL(url, window.location.origin);

        if (parsedUrl.origin !== window.location.origin) {
            return '';
        }

        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
        return '';
    }
}

function getStorageItem(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (error) {
        return null;
    }
}

function setStorageItem(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (error) {
    }
}

function removeStorageItem(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (error) {
    }
}
